export default [
  {
    path: "/LzfsAN5zHOJVgfw4V809mrwx",
    children: [
      {
        path: "",
        name: "myassignedLevel",
        meta: {
          authRequired: true,
          title: "Assigned arm(s)",
          acc: ["y31190"],
        },
        component: () => import("../views/assignedlevel/index.vue"),
      },
      {
        path: "kdjmkmd3o3kkk",
        name: "myassignedLeveli",
        meta: {
          authRequired: true,
          title: "Assigned arm trait",
          acc: ["y93347", 'y68529'],
        },
        component: () => import("../views/assignedlevel/index2.vue"),
      },

      {
        path: "efeweWDSsdsdsdxecereery/:lvl?",
        name: "myassignedLevelView",
        meta: {
          authRequired: true,
          title: "Assigned arm",
          acc: ["y98661"],
        },
        component: () => import("../views/assignedlevel/view.vue"),
      },
      {
        path: "efFgstyER7LUB4imewadadad/:lvl?",
        name: "myassignedLevelResultView",
        meta: {
          title: "View Result",
          authRequired: true,
          acc: ["y36897"],
        },
        component: () => import("../views/assignedlevel/viewresult.vue"),
      },
      {
        path: "efFgstyER7LUB4imewpwoetevt/:lvl?",
        name: "myassignedLevelResultViewi",
        meta: {
          title: "View students",
          authRequired: true,
          acc: ["y36897"],
        },
        component: () => import("../views/assignedlevel/viewresulti.vue"),
      },
      
      
    ],
  },
];
